/**
 * Validates if an href is valid for use in Next.js Link or anchor tags
 * @param href The href to validate
 * @returns true if the href is valid, false otherwise
 */
export const isValidHref = (href: string | undefined | null): boolean => {
  if (!href || href.trim() === '' || href === '//') {
    return false
  }
  return true
}

/**
 * Normalizes an href by extracting the pathname from full URLs
 * @param href The href to normalize
 * @returns The normalized href (pathname for URLs, or the original href)
 */
export const normalizeHref = (href: string | undefined | null): string => {
  if (!isValidHref(href)) {
    return '#'
  }

  let url = ''
  try {
    const urlObject = new URL(href ?? '')
    url = urlObject.pathname
  } catch {
    url = href ?? '#'
  }
  return url
}

/**
 * Safely normalizes and validates an href
 * Returns null if invalid, normalized href if valid
 * @param href The href to process
 * @returns The normalized href or null if invalid
 */
export const safeNormalizeHref = (
  href: string | undefined | null
): string | null => {
  if (!isValidHref(href)) {
    return null
  }
  return normalizeHref(href)
}

